module.exports = __webpack_public_path__ + "static/img/zhijiang.c87820e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhijiang.png
// module id = DY+U
// module chunks = 0